/**
 * Created by sasik on 11/18/15.
 */

var Sasik = {
    getToken : function () {
        return $('input[name=_token]').val();
    }
};
